import { action, observable, computed } from 'mobx';
import Alert from 'react-s-alert';

import { AppManager, App } from 'core/index';

import { emailValidator } from 'libs/forms/validators';
import { FormStore } from 'libs/forms/app';

import { modalStore } from 'apps/modals/app';

import { RequestResetPasswordMutation } from 'apps/signIn/gql';
import { conf } from 'apps/signIn/config.yaml';

class ResetPasswordApp extends App {
  static registryName = 'ResetPasswordApp';
  @observable usernameEmail = '';
  init() {
    this.form = new FormStore(this, conf, 'resetPasswordForm');
  }

  @computed get submitValue() {
    if (!emailValidator(this.usernameEmail)) {
      if (!this.usernameEmail.startsWith('@')) {
        return `@${this.usernameEmail}`;
      }
    }
    return this.usernameEmail;
  }

  @action Submit = () => {
    this.manager.Submit({
      onSuccess: this.onSuccess,
    });
  };

  @action onSuccess = () => {
    modalStore.ClearComponent();
    setTimeout(() => {
      Alert.success("We've sent an email if you exist in our system.");
    }, 300);
  };
}

export class ResetPasswordFormAppManager extends AppManager {
  static registryName = 'ResetPasswordFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.resetPasswordApp = new ResetPasswordApp(this, {});
    this.resetPasswordApp.init();
  }

  @action Submit = options => {
    this.mutations.push(
      RequestResetPasswordMutation.New(
        this.resetPasswordApp.submitValue,
        options,
      ),
    );
  };
}
